import React from 'react';
import styled from 'styled-components';

import { IInputContent } from '@belong/types';
import { RichText } from '../../styles/Typography/RichText/RichText';
import { SubDividerHeading } from '../../styles/Typography/SubDividerHeading';

const Content = (props: IInputContent & { className?: string }) => {
  const { content, icon, className } = props;

  return (
    <SubDividerHeading className={className} iconName={icon}>
      <RichText {...content} />
    </SubDividerHeading>
  );
};

Content.displayName = 'Content';
export default styled(Content)``;
